import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LedgerDetailDirective } from './ledger-detail.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [LedgerDetailDirective],
    exports: [LedgerDetailDirective],
})
export class LedgerDetailModule
{
}
